import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_MAPS, FETCH_MAP, MAP_REMOVE, MAP_SAVE, FETCH_ERROR } from './actions.type'
import { SET_MAPS, SET_MAPS_ERRORS, SET_MAPS_LOADING, SET_MAP, SET_MAP_ERRORS, SET_MAP_LOADING } from './mutations.type'

const state = {
	maps: [],
	mapsErrors: [],
	mapsIsLoading: false,
	map: null,
	mapErrors: [],
	mapIsLoading: false,
	mapLayersIsLoading: false
}

const getters = {
	maps:state => (key, filters = []) => {
		const searchKey = (key || '').toLowerCase()

		let filteredMaps = state.maps
		
		// Если фильтры не пустые и не содержат все доступные фильтры
		if (filters && filters.length > 0) {
			const hasSystemMaps = filters.includes('systemmaps')
			const hasUserMaps = filters.includes('usermaps')

			if (hasSystemMaps && hasUserMaps) {
				// Если выбраны оба фильтра, не фильтруем по типу, оставляем все карты
			} else if (hasSystemMaps) {
				// Только системные карты
				filteredMaps = filteredMaps.filter(x => x.user_map === false)
			} else if (hasUserMaps) {
				// Только пользовательские карты
				filteredMaps = filteredMaps.filter(x => x.user_map === true)
			} else {
				// Ошибка в фильтрах, добавлено какое то значение, которое не поддерживается, возвращаем пустой массив
				filteredMaps = []
				console.error('Ошибка в фильтрах maps.module, содержится не обратобанное значение', filters)
			}
		}

		return filteredMaps.filter(x => {
			if (!searchKey) {
				return true
			}

			return x.name && x.name.toLowerCase().includes(searchKey)
		})
		.sort((a, b) => a.name.localeCompare(b.name))
	},
	mapsErrors (state) {
		return state.mapsErrors
	},
	mapsIsLoading (state) {
		return state.mapsIsLoading
	},
	map (state) {
		return state.map
	},
	mapErrors (state) {
		return state.mapErrors
	},
	mapIsLoading (state) {
		return state.mapIsLoading
	}
}

const actions = {
	[FETCH_MAPS] (context, params) {
		context.commit(SET_MAPS_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/maps')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_MAPS, data)
					resolve(data)
				} else {
					context.commit(SET_MAPS_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_MAPS_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_MAPS_LOADING, false)
			})
		})
	},
	[FETCH_MAP] (context, params) {
		context.commit(SET_MAP_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.getBy('manager/maps', params.id)
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_MAP, data)
					resolve(data)
				} else {
					context.commit(SET_MAP_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_MAP_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_MAP_LOADING, false)
			})
		})
	},
	[MAP_SAVE] (context, params) {
		context.commit(SET_MAP_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.put(`manager/maps/${params.id}`, params)
			.then(({data}) => {
				if (data) {
					if (data === true) {
						this.dispatch(FETCH_ERROR, { variant: "success", text: "Карта сохранена", title: "Готово" })
					}
					else {
						this.dispatch(FETCH_ERROR, { variant: "success", text: "Карта создана", title: "Готово" })
					}
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				}		
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_MAP_LOADING, false)
			})
		})
	},
	[MAP_REMOVE] (context, id) {
		context.commit(SET_MAP_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.delete(`manager/maps/${id}`)
			.then(({data}) => {
				if (data) {
					state.maps = state.maps.filter(x => x.id != id)
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Карта удалена", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_MAP_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_MAPS] (state, data) {
		state.maps = data
		state.mapsErrors = []
	},
	[SET_MAPS_ERRORS] (state, errors) {
		state.maps = []
		state.mapsErrors = errors
	},
	[SET_MAPS_LOADING] (state, status = true) {
		state.mapsIsLoading = status
	},
	[SET_MAP] (state, data) {
		state.map = data
		state.mapErrors = []
	},
	[SET_MAP_ERRORS] (state, errors) {
		state.map = null
		state.mapErrors = errors
	},
	[SET_MAP_LOADING] (state, status = true) {
		state.mapIsLoading = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/maps.module.js